/** What `/_/health` answers (crates/trippath-web). */
export interface Health {
  status: 'ok';
  version: string;
  schema: number;
}

/** The server answered, but not with what the client expected. */
export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

/** Reads an answer into a [`Health`], or says it is not one (docs/02 §7: parse at the edge). */
export function parseHealth(value: unknown): Health {
  if (
    typeof value === 'object' &&
    value !== null &&
    'status' in value &&
    value.status === 'ok' &&
    'version' in value &&
    typeof value.version === 'string' &&
    'schema' in value &&
    typeof value.schema === 'number'
  ) {
    return { status: 'ok', version: value.version, schema: value.schema };
  }
  throw new ApiError('unexpected health answer');
}

/** Asks the server whether it is up and which schema it runs. */
export async function getHealth(fetcher: typeof fetch = fetch): Promise<Health> {
  const response = await fetcher('/_/health', { headers: { accept: 'application/json' } });
  if (!response.ok) {
    throw new ApiError(`health answered ${response.status}`);
  }
  return parseHealth(await response.json());
}
